import { LabelWithRequired } from '@motili/ui';
import { styled } from 'styled-components';

interface DatePickerLabelProps {
    label: string;
    required?: boolean;
}

const LabelContainer = styled.div`
    margin-bottom: 5px;
`;

const DatePickerLabel = ({ label, required = false }: DatePickerLabelProps) => {
    return (
        <LabelContainer>
            <LabelWithRequired label={label} required={required} />
        </LabelContainer>
    );
};

export default DatePickerLabel;
